export default class
{
    constructor()
    {
        this.callbacks = {}
        this.callbacks.base = {}
    }

    on(_names, callback)
    {
        const that = this

        if(typeof _names === 'undefined' || _names === '')
        {
            console.warn('emitter wrong names')
            return false
        }

        if(typeof callback === 'undefined')
        {
            console.warn('emitter wrong callback')
            return false
        }

        const names = this.resolveNames(_names)

        names.forEach(function(_name)
        {
            const name = that.resolveName(_name)

            if(!(that.callbacks[name.namespace] instanceof Object))
                that.callbacks[name.namespace] = {}

            if(!(that.callbacks[name.namespace][name.value] instanceof Array))
                that.callbacks[name.namespace][name.value] = []

            that.callbacks[name.namespace][name.value].push(callback)          
        })

        return this
    }

    trigger(_name, _args)
    {
        if(typeof _name === 'undefined' || _name === '')
        {
            console.warn('trigger wrong name')
            return false
        }

        const that = this
        let finalResult = null
        let result = null

        const args = !(_args instanceof Array) ? [] : _args

        let name = this.resolveNames(_name)

        name = this.resolveName(name[0])

        if(name.namespace === 'base')
        {
            for(const namespace in that.callbacks)
            {
                if(that.callbacks[namespace] instanceof Object && that.callbacks[namespace][name.value] instanceof Array)
                {
                    this.callbacks[namespace][name.value].forEach(function(callback)
                    {
                        result = callback.apply(that, args)

                        if(typeof finalResult === 'undefined')
                        {
                            finalResult = result
                        }
                    })
                }
            }
        }

        return finalResult
    }

    resolveNames(_names)
    {
        let names = _names
        names = names.replace(/[^a-zA-Z0-9 ,/.]/g, '')
        names = names.replace(/[,/]+/g, ' ')
        names = names.split(' ')

        return names
    }

    resolveName(name)
    {
        const newName = {}
        const parts = name.split('.')

        newName.original = name
        newName.value = parts[0]
        newName.namespace = 'base'

        if(parts.length > 1 && parts[1] !== '')
        {
            newName.namespace = parts[1]
        }

        return newName
    }
}